import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import HistoryIcon from '@mui/icons-material/History';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { InfoPersonalCliente } from './InfoPersonalCliente';

export function ModalGestiones({ cliente, mostrarModal, onCerrar, gestiones = [] }) {
    if (!mostrarModal) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
                {/* Header */}

                <div className="bg-gradient-to-r from-purple-600 to-indigo-600 px-6 py-4 flex items-center justify-between">
                    <div className="flex items-center gap-3">

                        <div className="p-2 bg-white bg-opacity-20 rounded-lg">
                            <HistoryIcon className="text-white" sx={{ fontSize: 28 }} />
                        </div>
                        <div>
                            <h2 className="text-2xl font-bold text-white">Historial de Gestiones</h2>
                            <p className="text-purple-100 text-sm">
                                {cliente?.nombre || 'Cliente'}
                            </p>
                        </div>
                    </div>
                    <button
                        onClick={onCerrar}
                        className="p-2 hover:bg-white hover:bg-opacity-10 rounded-lg transition-all"
                    >
                        <CloseIcon className="text-white" sx={{ fontSize: 24 }} />
                    </button>
                </div>

                {/* Body */}
                <div className="p-6 overflow-y-auto max-h-[calc(90vh-100px)]">
                    {/* Información del Cliente */}
                    <div className="mb-6 bg-gradient-to-r from-purple-50 to-indigo-50 rounded-xl p-4 border border-purple-200">
                        <InfoPersonalCliente cliente={cliente} />
                    </div>

                    {gestiones.length === 0 ? (
                        <div className="text-center py-12">
                            <div className="flex flex-col items-center gap-4">
                                <div className="p-4 bg-gray-100 rounded-full">
                                    <AssignmentIcon className="text-gray-400" sx={{ fontSize: 48 }} />
                                </div>
                                <div>
                                    <p className="text-gray-600 font-semibold text-lg">
                                        No hay gestiones registradas
                                    </p>
                                    <p className="text-gray-500 text-sm mt-1">
                                        Este cliente aún no tiene gestiones en el historial
                                    </p>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="overflow-x-auto max-h-[400px] overflow-y-auto border border-purple-200 rounded-lg">
                            <table className="w-full">
                                <thead className="bg-gradient-to-r from-purple-50 to-indigo-50 border-b-2 border-purple-200 sticky top-0">
                                    <tr>
                                        <th className="px-4 py-3 text-left text-xs font-bold text-purple-700 uppercase tracking-wider">
                                            #
                                        </th>
                                        <th className="px-4 py-3 text-left text-xs font-bold text-purple-700 uppercase tracking-wider">
                                            Motivo Continuidad
                                        </th>
                                        <th className="px-4 py-3 text-left text-xs font-bold text-purple-700 uppercase tracking-wider">
                                            Descripción
                                        </th>
                                        <th className="px-4 py-3 text-left text-xs font-bold text-purple-700 uppercase tracking-wider">
                                            Usuario
                                        </th>
                                        <th className="px-4 py-3 text-left text-xs font-bold text-purple-700 uppercase tracking-wider">
                                            Fecha
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                    {gestiones.map((gestion, idx) => (
                                        <tr 
                                            key={idx} 
                                            className="hover:bg-purple-50 transition-colors duration-150"
                                        >
                                            <td className="px-4 py-4">
                                                <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-purple-100 text-purple-700 font-bold text-sm">
                                                    {idx + 1}
                                                </span>
                                            </td>
                                            <td className="px-4 py-4">
                                                <span className={`inline-flex items-center px-3 py-1 rounded-full font-semibold text-xs border ${
                                                    gestion.motivoContinuidad?.Nombre?.toLowerCase().includes('no responde')
                                                        ? 'bg-red-50 text-red-700 border-red-200'
                                                        : gestion.motivoContinuidad?.Nombre?.toLowerCase().includes('cancelado')
                                                        ? 'bg-orange-50 text-orange-700 border-orange-200'
                                                        : gestion.motivoContinuidad?.Nombre?.toLowerCase().includes('completado')
                                                        ? 'bg-green-50 text-green-700 border-green-200'
                                                        : gestion.motivoContinuidad?.Nombre?.toLowerCase().includes('pendiente')
                                                        ? 'bg-yellow-50 text-yellow-700 border-yellow-200'
                                                        : 'bg-blue-50 text-blue-700 border-blue-200'
                                                }`}>
                                                    {gestion.motivoContinuidad?.Nombre || 'Sin motivo'}
                                                </span>
                                            </td>
                                            <td className="px-4 py-4">
                                                <p className="text-sm text-gray-700">
                                                    {gestion.Descripcion || 'Sin descripción'}
                                                </p>
                                            </td>
                                            <td className="px-4 py-4">
                                                <span className="inline-flex items-center px-2 py-1 rounded-md bg-indigo-50 text-indigo-700 font-medium text-xs">
                                                    {gestion.Usuario || 'N/A'}
                                                </span>
                                            </td>
                                            <td className="px-4 py-4">
                                                <span className="text-sm text-gray-600">
                                                    {gestion.FechaSistema 
                                                        ? new Date(gestion.FechaSistema).toLocaleString('es-ES', {
                                                            day: '2-digit',
                                                            month: 'short',
                                                            year: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit'
                                                        })
                                                        : 'N/A'
                                                    }
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* Footer con total */}
                    {gestiones.length > 0 && (
                        <div className="mt-6 pt-4 border-t border-gray-200">
                            <div className="flex items-center justify-between">
                                <p className="text-sm text-gray-600">
                                    Total de gestiones: <span className="font-bold text-purple-600">{gestiones.length}</span>
                                </p>
                                <button
                                    onClick={onCerrar}
                                    className="px-6 py-2 bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-semibold rounded-lg hover:from-purple-700 hover:to-indigo-700 transition-all duration-200 shadow-md hover:shadow-lg"
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
